export const GROUP_OPTIONS = [
	{ value: 'nhssaa', label: 'NHSSAA' },
	{ value: '101', label: '101' },
	{ value: '201', label: '201' },
];

/**
 * Groups a student can pick at signup. Only NHSSAA has a signup flow (the parent-consent
 * step); the 101/201 course cohorts are assigned by staff and exist for the leaderboard.
 */
export const SIGNUP_GROUP_OPTIONS = GROUP_OPTIONS.filter(({ value }) => value === 'nhssaa');
